import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  formateDate,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { showErrorMessage } from "../Shared/Toast";

function StorageRecord() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState<any>({});
  const [filterObject, setFilterObject] = useState({
    jobid: "",
    statustype: 1,
  });
  const [screenData, setScreenData] = useState<any>([]);
  const [breakDownData, setBreakDownData] = useState<any>([]);
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    getScreenData();
  }, []);

  function getScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.jobid = filterObject.jobid;
    object.statustype = filterObject.statustype;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteStorageData/MNVQuoteStorageDataGetCompleteGridDataCustom",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse[0]));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse[0]));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          setScreenData(l_oResponse[0]);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function MNVQuoteStorageDataGetChargesBreakdown(jobid: any, statustype: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.jobid = jobid;
    object.statustype = statustype;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteStorageData/MNVQuoteStorageDataGetChargesBreakdown",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;

          setShowModal(true);
          setBreakDownData(l_oResponse[0]);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;

    if (IsOkay == true) {
      saveScreenData();
    }
  }

  function saveScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvquotestoragedataid = addEditObject.MNVQuoteStorageDataID;
    object.unitnumber = addEditObject.UnitNumber;
    object.specialnotes = addEditObject.SpecialNotes;
    object.priceagreed =
      addEditObject.PriceAgreed == "" ? null : addEditObject.PriceAgreed;
    object.paymentpaiduntil =
      addEditObject.PaymentPaidUntil == "" ||
      addEditObject.PaymentPaidUntil == "Invalid date"
        ? null
        : addEditObject.PaymentPaidUntil;
    object.noticeprovided =
      addEditObject.NoticeProvided == "" ? null : addEditObject.NoticeProvided;
    object.movedoutdate =
      addEditObject.MovedOutDate == "" ||
      addEditObject.MovedOutDate == "Invalid date"
        ? null
        : addEditObject.MovedOutDate;
    object.isactive = addEditObject.IsActive;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteStorageData/MNVQuoteStorageDataSaveCustom",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message);
          } else {
            setIsAddNew(0);
            getScreenData();
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvquotestoragedataid = pid;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteStorageData/MNVQuoteStorageDataDeleteRecord",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getScreenData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVMoverName")) {
        (
          document.getElementById(
            "imgSort" + "MNVMoverName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "DTDPerHourRateName")) {
        (
          document.getElementById(
            "imgSort" + "DTDPerHourRateName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "PTDPerHourRateName")) {
        (
          document.getElementById(
            "imgSort" + "PTDPerHourRateName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <div className="flex-da gap-10">
              <div className="field-input">
                <input
                  className="input-field"
                  placeholder="Job ID"
                  value={filterObject.jobid}
                  onChange={(e) =>
                    setFilterObject((prevState: any) => ({
                      ...prevState,
                      jobid: e.target.value,
                    }))
                  }
                ></input>
              </div>
              <div className="field-input">
                <select
                  className="input-field"
                  value={filterObject.statustype}
                  onChange={(e) =>
                    setFilterObject((prevState: any) => ({
                      ...prevState,
                      statustype: e.target.value,
                    }))
                  }
                >
                  <option value={0}>All</option>
                  <option value={1}>Active</option>
                  <option value={2}>Closed</option>
                </select>
              </div>

              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => getScreenData()}
                >
                  Filter
                </a>
              </div>
            </div>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                {/* <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({});
                    setIsAddNew(1);
                  }}
                >
                  Add New
                </a> */}
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() => DownloadClientsDataInExcel("tblmover", "Storage Record")}
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto-sm">
            <table className="reuse-table" id="tblmover">
              <thead>
                <tr>
                  <th className="td-xxxs">
                    <div className="flex-daj flex-gap5">
                      Active
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "IsActive")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("IsActive")}
                        title={"Sort By Active"}
                      >
                        <span id={"imgSort" + "IsActive"}></span>
                      </a>
                    </div>
                  </th>
                  {/* <th>
                  <div className="flex-d flex-ac flex-jc flex-gap20">
                    <div className="flex-d flex-ac flex-gap5">
                      Store Number
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "StoreNumber")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("StoreNumber")}
                        title={"Sort Store Number"}
                      >
                        <span id={"imgSort" + "StoreNumber"}></span>
                      </a>
                    </div>
                  </div>
                </th> */}
                  <th className="td-sm">
                    <div className="flex-daj flex-gap5">
                      Store Location
                      <a
                        onClick={(e) =>
                          ShowColumnFilterList(e, "StoreLocation")
                        }
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() =>
                          LoadWithSelectedSort("PTDPerHourRateName")
                        }
                        title={"Sort By StoreLocation"}
                      >
                        <span id={"imgSort" + "StoreLocation"}></span>
                      </a>
                    </div>
                  </th>
                  <th className=" td-xxxs">Job Number</th>
                  <th className="td-sm">Client Name</th>
                  <th>Unit Number</th>
                  <th className="td-sm">Special Notes</th>
                  <th className="td-xxxs">Unit size SQFT</th>
                  <th>Declared Value</th>
                  <th className=" td-xxxs">Moved In</th>
                  {/* <th>Price Agreed (inc. VAT) £</th> */}
                  <th>1st Payment (inc. VAT) £</th>
                  <th>Total Paid (inc. VAT) £</th>
                  <th className="td-xxxs">Paid Until</th>
                  <th className="td-xxxs">Notice Provided</th>
                  <th className="td-xxxs">Moved Out Date</th>
                  <th className="td-xxxs">Action</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td className=" td-xxxs">
                            {item.IsActive == true ? "Yes" : "No"}
                          </td>
                          {/* <td>{item.StoreNumber}</td> */}
                          <td>{item.StoreLocation}</td>
                          <td className="td-xxxs">
                            <a
                              className="flex-da click-link flex-jsb"
                              href={"/quote_detail/" + item.MNVJobID}
                              target="_blank"
                            >
                              <span>#{item.JobID}</span>
                            </a>
                          </td>
                          <td>{item.ClientName}</td>
                          <td>{item.UnitNumber}</td>
                          <td>{item.SpecialNotes}</td>
                          <td className="text-right  td-xxxs">
                            {item.AreaSquareFeet}
                          </td>
                          <td className="text-right">
                            £
                            {item.DeclaredValue?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                          <td className=" td-xxxs">
                            {formateDate(item.MovedIn)}
                          </td>
                          {/* <td>
                            £
                            {item.PriceAgreed?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td> */}
                          <td className="text-right">
                            £
                            {item.FirstPayment?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                          <td className="text-right">
                            <div className="flex-da justify-end">
                              <a
                                className="flex-da click-link flex-jsb"
                                href={"/invoicedata?j=" + item.JobID}
                                target="_blank"
                              >
                                £
                                {item.TotalPaid?.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </a>
                            </div>
                          </td>
                          <td className="td-xxxs">
                            {formateDate(item.PaymentPaidUntil)}
                          </td>
                          <td className="td-xxxs">
                            {item.NoticeProvided == 1 ? "Yes" : "No"}
                          </td>
                          <td className="td-xxxs">
                            {formateDate(item.MovedOutDate)}
                          </td>
                          <td className="td-xxxs">
                            <div className="flex-daj gap-10">
                                <a
                                title="Charges Breakdown"
                                onClick={() => {
                                  MNVQuoteStorageDataGetChargesBreakdown(
                                  item.JobID,
                                    0,
                                  );
                                }}
                              >
                                <img
                                  src="images/pound.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>  
                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  setAddEditObject(item);
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                            
                              {/* <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.MNVQuoteStorageDataID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a> */}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Unit Number:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.UnitNumber}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      UnitNumber: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Special Notes:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.SpecialNotes}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      SpecialNotes: e.target.value,
                    }))
                  }
                />
              </div>
              {/* <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Price Agreed (inc. VAT) £:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.PriceAgreed}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PriceAgreed: e.target.value,
                    }))
                  }
                />
              </div> */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Paid Until:
                </span>
                <input
                  type="Date"
                  className="input-field w-100"
                  value={moment(addEditObject.PaymentPaidUntil).format(
                    "YYYY-MM-DD",
                  )}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PaymentPaidUntil: moment(e.target.value).format(
                        "YYYY-MM-DD",
                      ),
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Notice Provided:
                </span>

                <select
                  className="input-field w-100"
                  value={addEditObject.NoticeProvided}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      NoticeProvided: e.target.value,
                    }))
                  }
                >
                  <option value={0}>No</option>
                  <option value={1}>Yes</option>
                </select>
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Moved Out Date:
                </span>
                <input
                  className="input-field w-100"
                  type="Date"
                  value={moment(addEditObject.MovedOutDate).format(
                    "YYYY-MM-DD",
                  )}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MovedOutDate: moment(e.target.value).format("YYYY-MM-DD"),
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">Active:</span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.IsActive}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      IsActive: e.target.checked ? 1 : 0,
                    }))
                  }
                />
              </div>
            </div>
            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}



      {showModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner md-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Charges Breakdown</h3>
                <a className="close-help" onClick={() => setShowModal(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="flow-auto-lg mt-10">
                <table className="reuse-table">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th className="text-right">Amount</th>
                      <th>Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {breakDownData && breakDownData.map((Row: any, index: any) => (
                      <tr key={index}>
                        <td>{Row.Title}</td>

                        <td className="text-right">
                          £
                          {Number(Row.Amount)?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="text-right">{formateDate(Row.Dated)}</td>
                      </tr>
                    ))}

                  </tbody>
                </table>
              </div>
              <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}


    </div>
  );
}

export default StorageRecord;
